var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ParallaxBlock',{staticClass:"p-whoiam-section",class:_vm.classnames,attrs:{"scrollY":_vm.scrollY,"parallaxRatio":_vm.parallaxRatio}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }